import React from "react";
import One from "./svgs/key1";
import { Two } from "./svgs/key2";
import { Three } from "./svgs/key3";
import { Four } from "./svgs/key4";
import { Five } from "./svgs/key5";
import { Six } from "./svgs/key6";

export const KeyFeatures = () => {
  return (
    <section className="stitch-features mt-0 py-24 relative overflow-hidden">
      
      <div>
        <div className="stitch-section-kicker"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <span className="text-transparent text-sm md:text-lg bg-clip-text bg-gradient-to-b from-[#AFA4FF] to-[#D19CFF]">
            Some of Main Features!
          </span>
        </div>
        <div className="stitch-section-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          Our Key Features
        </div>

        <div className="stitch-section-copy"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.6 }}
        >
          AI Agents are designed to revolutionize your customer
          interactions. With advanced artificial intelligence, they provide
          highly efficient, personalized, and seamless communication, ensuring
          that every customer call is handled with precision. Whether it's
          answering inquiries, providing information, or assisting with tasks,
          AI Agents offer round-the-clock service that enhances the overall
          customer experience and boosts operational efficiency for your
          business.
        </div>
      </div>
      <div
        className="stitch-feature-grid mx-[8%] md:mx-[15%] mt-16 rounded-2xl"
        style={{
          background: "radial-gradient(ellipse 50% 50% at center, #7E35FB, transparent)"
        }}
      >
        {" "}
        <div className="grid md:grid-cols-2 md:grid-rows-2 lg:grid-cols-3 lg:grid-rows-2 gap-x-0.5 gap-y-0.5">
          <div className="bg-black rounded-none rounded-br-2xl p-4 h-64 hover:bg-gradient-to-tl hover:from-[#5423A8] hover:via-darkPurple hover:to-black transition duration-300">
            <div className="flex justify-center">
              {" "}
              <One />
            </div>

            <div className="mt-7 text-center">
              <h1 className="text-lg lg:text-2xl font-semibold text-white">
                Intelligent Assistance
              </h1>
              <p className="text-sm lg:text-lg mx-[20%] mt-2 text-gray-200">
              AI Agent analyzes and replies with intelligence.
              </p>
            </div>
          </div>
          <div className="bg-black rounded-none lg:rounded-b-2xl p-4 h-64 hover:bg-gradient-to-t hover:from-[#5423A8] hover:via-[#09070f] hover:to-black transition duration-300">
            <div className="flex justify-center">
              {" "}
              <Two />
            </div>

            <div className="mt-7 text-center">
              <h1 className="text-lg lg:text-2xl font-semibold text-white">
                24 Hours Coverage
              </h1>
              <p className="text-sm lg:text-lg mx-[20%] mt-2 text-gray-200">
              AI Agent works 24/7, ensuring you're always supported.
              </p>
            </div>
          </div>
          <div className="bg-black p-4 h-64 rounded-none lg:rounded-bl-2xl hover:bg-gradient-to-tr hover:from-[#5423A8] hover:via-darkPurple hover:to-black transition duration-300">
            <div className="flex justify-center">
              {" "}
              <Three />
            </div>

            <div className="mt-7 text-center">
              <h1 className="text-lg lg:text-2xl font-semibold text-white">
                Proper Searching
              </h1>
              <p className="text-sm lg:text-lg mx-[20%] mt-2 text-gray-200">
              AI Agent analyzes your queries, context-aware answers.
              </p>
            </div>
          </div>
          <div className="bg-black p-4 h-64 rounded-none lg:rounded-tr-2xl hover:bg-gradient-to-bl hover:from-[#5423A8] hover:via-darkPurple hover:to-black transition duration-300">
            <div className="flex justify-center pt-5">
              {" "}
              <Four />
            </div>

            <div className="mt-7 text-center">
              <h1 className="text-lg lg:text-2xl font-semibold text-white">
                Professional Voice
              </h1>
              <p className="text-sm lg:text-lg mx-[20%] mt-2 text-gray-200">
              AI Agent provides clear voice, for smooth communication.
              </p>
            </div>
          </div>
          <div className="bg-black p-4 h-64 rounded-none lg:rounded-t-2xl hover:bg-gradient-to-b hover:from-[#5423A8] hover:via-[#09070f] hover:to-black transition duration-300">
            <div className="flex justify-center pt-4">
              {" "}
              <Five />
            </div>

            <div className="mt-7 text-center">
              <h1 className="text-lg lg:text-2xl font-semibold text-white">
                Natural Behavior
              </h1>
              <p className="text-sm lg:text-lg mx-[20%] mt-2 text-gray-200">
              AI Agent responds with authentic pauses, ums, and uhs,
              </p>{" "}
            </div>
          </div>
          <div className="bg-black p-4 h-64 rounded-none lg:rounded-tl-2xl hover:bg-gradient-to-br hover:from-[#5423A8] hover:via-darkPurple hover:to-black transition duration-300">
            <div className="flex justify-center pt-4">
              {" "}
              <Six />
            </div>

            <div className="mt-7 text-center">
              <h1 className="text-lg lg:text-2xl font-semibold text-white">
                CRM Integration
              </h1>
              <p className="text-sm lg:text-lg mx-[20%] mt-2 text-gray-200">
              AI Agent is integrated with your CRM to
                provide intelligence
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
